import { setPlayerTutorialCompleted } from "@dailywars/core/db";
import { createServerFn } from "@tanstack/react-start";

import { getRequestLogger, logRequestError } from "#/lib/requestLogger.server";
import { emptyServerInputSchema } from "#/lib/serverInputSchemas";
import { authedMiddleware } from "#/server/authedMiddleware";

export const markTutorialCompleted = createServerFn({ method: "POST" })
  .middleware([authedMiddleware])
  .validator(emptyServerInputSchema)
  .handler(async ({ context }) => {
    getRequestLogger().set({ profile: { action: "mark_tutorial_completed" } });
    try {
      await setPlayerTutorialCompleted(context.userId);
    } catch (error) {
      logRequestError({
        log: getRequestLogger(),
        error,
        context: { profile: { step: "mark_tutorial_completed" } },
      });
      throw error;
    }
  });
